import { MdLocationOn } from "react-icons/md";
import IconItem from "../../../../../components/Atoms/IconItem";
import { EventTracker } from "../../../../Atoms/Analytics";
import BulletList from "../../../../Atoms/BulletList";
import GoogleMapsFrame, {
  generateGoogleMapsUrl,
} from "../../../../Cards/GoogleMapsFrame";
import styles from "./MeetingPlace.module.scss";

function notEmptyLine(text: string) {
  return !!text;
}

function removeHandmadeBulletPoints(text: string) {
  return text.replace(/^- /, "");
}

function toLines(text: string) {
  const lines = text.split(/\n|\r/);

  return lines.filter(notEmptyLine).map(removeHandmadeBulletPoints);
}

export type MeetingPlaceProps = {
  name: string;
  description: string;
  googleMapsUrl: string;
  query?: any;
  showLabel?: boolean;
};

export default function MeetingPlace({
  name,
  description,
  googleMapsUrl,
  query,
  showLabel,
}: MeetingPlaceProps) {
  return (
    <>
      {showLabel && <p className="DetailTitle">Meeting Point</p>}
      <div className={styles.MeetingPlaceWrapper}>
        <IconItem icon={<MdLocationOn size={24} />}>
          <p>{name}</p>
        </IconItem>
        {query && <GoogleMapsFrame query={query} />}
        <EventTracker
          onClick={{
            category: "detail-meeting-place",
            action: "click",
            label: "google-map-link",
          }}
        >
          <a
            style={{ display: "inline-block", marginBottom: 20 }}
            className="ExternalLink"
            href={query ? generateGoogleMapsUrl(query) : googleMapsUrl}
            target="_blank"
            rel="noreferrer"
          >
            See on google maps
          </a>
        </EventTracker>
        {description && <BulletList items={toLines(description)} />}
      </div>
    </>
  );
}
